import React, { useState } from 'react';
import { FolderIcon, FileIcon, VideoIcon, FileTextIcon, ImageIcon, ChevronRightIcon, DownloadIcon, EyeIcon, XIcon } from 'lucide-react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
interface Material {
  id: string;
  name: string;
  type: 'video' | 'pdf' | 'image' | 'document';
  size: string;
  date: string;
}
interface Folder {
  id: string;
  name: string;
  fileCount: number;
  materials: Material[];
}
const foldersData: Folder[] = [{
  id: '1',
  name: 'Climate Change 101',
  fileCount: 12,
  materials: [{
    id: '1-1',
    name: 'Introduzione al cambiamento climatico.mp4',
    type: 'video',
    size: '245 MB',
    date: '15 Dic 2024'
  }, {
    id: '1-2',
    name: 'Slide Lezione 1.pdf',
    type: 'pdf',
    size: '2.3 MB',
    date: '15 Dic 2024'
  }, {
    id: '1-3',
    name: 'Grafici temperatura globale.png',
    type: 'image',
    size: '890 KB',
    date: '15 Dic 2024'
  }]
}, {
  id: '2',
  name: 'Casa Efficiente',
  fileCount: 8,
  materials: [{
    id: '2-1',
    name: 'Isolamento termico.mp4',
    type: 'video',
    size: '189 MB',
    date: '10 Dic 2024'
  }, {
    id: '2-2',
    name: 'Guida risparmio energetico.pdf',
    type: 'pdf',
    size: '1.8 MB',
    date: '10 Dic 2024'
  }]
}, {
  id: '3',
  name: 'Mobilità Sostenibile',
  fileCount: 15,
  materials: [{
    id: '3-1',
    name: 'Trasporti pubblici vs auto.mp4',
    type: 'video',
    size: '312 MB',
    date: '5 Dic 2024'
  }, {
    id: '3-2',
    name: 'Calcolo emissioni CO2.pdf',
    type: 'pdf',
    size: '3.1 MB',
    date: '5 Dic 2024'
  }]
}, {
  id: '4',
  name: 'Risorse Community',
  fileCount: 24,
  materials: [{
    id: '4-1',
    name: 'Template report ESG.pdf',
    type: 'pdf',
    size: '1.2 MB',
    date: '1 Dic 2024'
  }, {
    id: '4-2',
    name: 'Checklist sostenibilità.pdf',
    type: 'pdf',
    size: '890 KB',
    date: '1 Dic 2024'
  }]
}];
const MaterialsPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState<Folder | null>(null);
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'video':
        return <VideoIcon size={20} className="text-red-600" data-id="element-2712" />;
      case 'pdf':
        return <FileTextIcon size={20} className="text-red-600" data-id="element-2713" />;
      case 'image':
        return <ImageIcon size={20} className="text-blue-600" data-id="element-2714" />;
      default:
        return <FileIcon size={20} className="text-gray-600" data-id="element-2715" />;
    }
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-2716">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2717">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2718"></div>
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2719">
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2720">
            <Sidebar activePage="formazione" data-id="element-2721" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2722">
        <Sidebar activePage="formazione" data-id="element-2723" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2724">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2725" />

        <main className="flex-1 overflow-y-auto p-4 md:p-8 bg-gray-50" data-id="element-2726">
          <div className="max-w-7xl mx-auto" data-id="element-2727">
            {/* Header */}
            <div className="mb-6" data-id="element-2728">
              <div className="flex items-center gap-2 text-sm text-gray-600 mb-2" data-id="element-2729">
                <button onClick={() => setSelectedFolder(null)} className="hover:text-gray-900 transition-colors" data-id="element-2730">
                  Materiali
                </button>
                {selectedFolder && <>
                    <ChevronRightIcon size={16} data-id="element-2731" />
                    <span className="text-gray-900 font-medium" data-id="element-2732">
                      {selectedFolder.name}
                    </span>
                  </>}
              </div>
              <h1 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-2733">
                {selectedFolder ? selectedFolder.name : 'Materiali'}
              </h1>
              <p className="text-sm text-gray-600 font-normal" data-id="element-2734">
                {selectedFolder ? `${selectedFolder.fileCount} file disponibili` : 'Accedi a tutti i materiali dei corsi'}
              </p>
            </div>

            {/* Content */}
            {!selectedFolder /* Folders Grid */ ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2735">
                {foldersData.map(folder => <button key={folder.id} onClick={() => setSelectedFolder(folder)} className="bg-white rounded-xl border border-gray-200 p-6 hover:border-green-600 hover:shadow-sm transition-all text-left" data-id="element-2736">
                    <div className="flex items-center justify-between mb-4" data-id="element-2737">
                      <div className="w-12 h-12 rounded-lg bg-green-50 flex items-center justify-center" data-id="element-2738">
                        <FolderIcon size={24} className="text-green-600" data-id="element-2739" />
                      </div>
                    </div>
                    <h3 className="font-medium text-gray-900 mb-1" data-id="element-2740">
                      {folder.name}
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-2741">
                      {folder.fileCount} file
                    </p>
                  </button>)}
              </div> /* Files List */ : <div className="space-y-3" data-id="element-2742">
                {selectedFolder.materials.map(material => <div key={material.id} className="bg-white rounded-xl border border-gray-200 p-4 hover:border-green-600 transition-colors" data-id="element-2743">
                    <div className="flex items-center justify-between" data-id="element-2744">
                      <div className="flex items-center gap-3 flex-1" data-id="element-2745">
                        <div className="w-10 h-10 rounded-lg bg-gray-50 flex items-center justify-center flex-shrink-0" data-id="element-2746">
                          {getFileIcon(material.type)}
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-2747">
                          <h4 className="font-medium text-gray-900 truncate" data-id="element-2748">
                            {material.name}
                          </h4>
                          <div className="flex items-center gap-3 text-xs text-gray-500 mt-1" data-id="element-2749">
                            <span data-id="element-2750">{material.size}</span>
                            <span data-id="element-2751">•</span>
                            <span data-id="element-2752">{material.date}</span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2753">
                        <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2754">
                          <EyeIcon size={18} className="text-gray-600" data-id="element-2755" />
                        </button>
                        <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2756">
                          <DownloadIcon size={18} className="text-gray-600" data-id="element-2757" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>}
          </div>
        </main>
      </div>
    </div>;
};
export default MaterialsPage;